import { render, staticRenderFns } from "./MaterialsUsed.vue?vue&type=template&id=1fa03752&scoped=true&"
import script from "./MaterialsUsed.vue?vue&type=script&lang=js&"
export * from "./MaterialsUsed.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsUsed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MaterialsUsed.vue?vue&type=style&index=1&id=1fa03752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa03752",
  null
  
)

export default component.exports